<template>
    <component
        :is="filterTemplate"
        v-bind="componentProps"
        @selectCategory="selectCategory"
        @setSearchQuery="setSearchQuery"        
    />   
</template>
<script>
import BlogPostCardFilters1 from "../../../author/pagesbuilder/templates/BlogPostCardFilters1";
import BlogPostCardFilters2 from "../../../author/pagesbuilder/templates/BlogPostCardFilters2";
import BlogPostCardFilters3 from "../../../author/pagesbuilder/templates/BlogPostCardFilters3";
    
export default {
    name : "BlogPostFiltersComponent",
    data () {
        return {
            componentType: "blog-post-filters",
            rendersWithVue: true,            
            selectedCategory: null            
        }
    },
    computed:{
        contextWrapper () {
            return this.hasContext("context-wrapper") ? this.findNodeState(this.hasContext("context-wrapper")[0].id) : null;
        },
        getPrimaryNodeState () {
                return this.contextWrapper && this.contextWrapper.getPrimaryNodeState ? this.contextWrapper.getPrimaryNodeState : null ;
        },
        blogPostCategories(){
            if(!this.contextWrapper || !this.contextWrapper.getPrimaryNodeState || !this.contextWrapper.getPrimaryNodeState.blogPostCategories ){
                return [];
            }
            return this.getPrimaryNodeState.blogPostCategories;
        },
        showCategories(){
            if(!this.getPrimaryNodeState){
                return false;
            }
            return this.getPrimaryNodeState.filters?.categories;
        },
        filterTemplate(){
            if(!this.getPrimaryNodeState){
                return null;
            }
            return this.getPrimaryNodeState.filterTemplate || null;
        },
        showSearch(){
            if(!this.getPrimaryNodeState){
                return false;
            }
            return this.getPrimaryNodeState.filters?.search;
        },
        hasFilters(){
            return this.showSearch || this.showCategories;
        },
        componentProps(){
            return {
                blogPostCategories: this.blogPostCategories,
                showCategories: this.showCategories,
                showSearch: this.showSearch,
                selectedCategory: this.selectedCategory,
            }
        }
    },  
    methods:{        
        selectCategory(category){

        },
        setSearchQuery(search){

        }
    },
    watch:{
        hasFilters: {
            handler(newVal){
                if(!this.myNode){
                    return;
                }                
                this.myNode.style.display = (newVal)? null : 'none';

            }
        }
    },
    components:{
        BlogPostCardFilters1,
        BlogPostCardFilters2,
        BlogPostCardFilters3

    }
    
}
</script>